import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';






@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

title = 'SportfishingMX-Expedicion de Licencias';

  constructor(
    private titleService: Title,
    private meta: Meta
  ) {}


  fechadeInicio: Date;
  fechaFinal: Date;

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTag({name: 'sportfishinmx', content: 'expedicion de licncias de pesca'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});
    this.meta.updateTag({name: 'keywords', content: 'Licencias, Permisos, Permiso, Pesca, Pesca Deportiva, Sportfishing, Ocean'});
    this.meta.updateTag({name: 'description', content: 'Pesca Deportiva, Deporte'});

  }




}
